// extracted by mini-css-extract-plugin
export default {"container":"AllGroupPosts_container__TsjR6"};